import { connect } from 'react-redux';

import { userManagementActions } from "dataflow/billingPortal/actions";

import { UserGroupPresentation } from './UserGroupPresentation';

function mapStateToProps(state) {
    const { 
        getUserList_requesting, 
        userList,

        getUserGroupPermissionList_requesting, userGroupPermissionList,

        addPermission_requesting, 
        removePermission_requesting,
        
        getUserGroupList_requesting,
        userGroupList, userGroupListHeaders,

        deleteUserGroup_requesting, deleteUserGroup_status,

        addUserGroupMapping_requesting,
        removeUserGroupMapping_requesting,

        isUserRecordUpdatedSuccessfully,
        totalRequests,

        userPermissions
    } = state.userManagementReducers;
    
	return {
        getUserList_requesting, 
        userList,

        getUserGroupPermissionList_requesting, userGroupPermissionList,

        addPermission_requesting, 
        removePermission_requesting,

        getUserGroupList_requesting,
        userGroupList, userGroupListHeaders,

        deleteUserGroup_requesting, deleteUserGroup_status,

        addUserGroupMapping_requesting,
        removeUserGroupMapping_requesting,

        isUserRecordUpdatedSuccessfully,
        totalRequests,

        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUserGroupList: (pageNo, pageSize, sort, filterOptions) => { dispatch(userManagementActions.getUserGroupList(pageNo, pageSize, sort, filterOptions)); },
        getList: () => { dispatch(userManagementActions.getUserList()); },
        getUserGroupPermissionList: () => { dispatch(userManagementActions.getUserGroupPermissionList()); },

        deleteUserGroup: (userId) => { dispatch(userManagementActions.deleteUserGroup(userId)); },
        addUserGroup: (userInfo) => { dispatch(userManagementActions.addUserGroup(userInfo)); },

        addUserGroupMapping: (userInfo) => { dispatch(userManagementActions.addUserGroupMapping(userInfo)); },
        removeUserGroupMapping: (userGroupId) => { dispatch(userManagementActions.removeUserGroupMapping(userGroupId)); },

        addPermission: (permissionList) => { dispatch(userManagementActions.addPermission(permissionList)); },
        removePermission: (permissionList) => { dispatch(userManagementActions.removePermission(permissionList)); },
    };
}

const UserGroup = connect(mapStateToProps, mapDispatchToProps)(UserGroupPresentation);

export default UserGroup;